module.exports = __webpack_public_path__ + "assets/blood-transfusion.1e070304.svg";